export const QARole = process.env.REACT_APP_QA_ROLE as string;
export const ElectoralCommitteeRole = process.env.REACT_APP_COMMITTEE_ROLE  as string;